<template>
  <TheModal @close="closeModal" type="textarea" @save="submit" title="ПРИЕМАНЕ">
    <section class="confirm-modal">
      <TheInput
        label="БЕЛЕЖКА ПРИ ПРИЕМАНЕ (НЕЗАДЪЛЖИТЕЛНО)"
        placeholder="БЕЛЕЖКА"
        type="textarea"
        :dark="true"
        :textareaRows="13"
        v-model="inventory.confirmNote"
      />
    </section>
  </TheModal>
</template>

<script>
import TheModal from "@/components/shared/TheModal.vue";
import TheInput from "@/components/TheInput.vue";
import log from "../mixins/log.js";
export default {
  mixins: [log],
  props: ["id"],
  components: {
    TheInput,
    TheModal,
  },
  data() {
    return {
      inventory: {},
    };
  },
  methods: {
    getInventoryName(i) {
      return [i.name, i.brand, i.serialNumber].filter((x) => x).join(" - ");
    },
    getInventory(id) {
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/inventory/${id}`)
        .then((response) => {
          this.inventory = response.data;
        });
    },
    submit() {
      const fd = new FormData();
      fd.append("data", JSON.stringify(this.inventory));

      this.$http
        .put(`${process.env.VUE_APP_BASE_URI}/inventory`, fd)
        .then(() => {
          this.$snotify.success("Успешно редактирахте инвентар!");
          this.newLog("editInventory", this.getInventoryName(this.inventory));

          this.closeModal(true);
        })
        .catch((error) => {
          if (typeof error.response.data === "string") {
            this.$snotify.error(error.response.data);
          } else {
            console.log(error.response);
            this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
          }
        })
        .then(() => {});
    },
    closeModal(isEdited) {
      // isEdited = true => means something is changed
      // isEdited = false => just close the modal
      this.$emit("close", isEdited ? this.inventory : false);
    },
  },
  mounted() {
    if (this.id) this.getInventory(this.id);
  },
};
</script>
